import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import './checkbox.scss';
const Checkbox = ({ checked, isFetching, onClick, label, name }) => (_jsxs("label", { htmlFor: name, className: "checkbox", children: [_jsx("span", { className: checked ? 'label--checked' : 'label', children: label }), _jsx("input", { id: name, checked: checked, value: checked, type: "checkbox", name: name, onChange: onClick }), _jsx("span", { className: "checkmark", children: isFetching && (_jsx("span", { className: `${checked ? 'circle-loader-green' : 'circle-loader-white'}` })) })] }));
Checkbox.propTypes = {
    checked: PropTypes.bool,
    isFetching: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
};
Checkbox.defaultProps = {
    checked: false,
    isFetching: false,
};
export default Checkbox;
